export default __webpack_public_path__ + "static/media/profile.c0610f40.webp";